
import { Grid } from '@material-ui/core';
import { GridCellParams, GridColumns, GridRowData } from '@material-ui/data-grid';
import { EventsProps } from '../../../Interfaces/Interfaces';
import Table from '../../Table/Table';

const Events = (props: EventsProps) => {
	const { events } = props;
    const headers:GridColumns = [
        { field: 'createdDate', headerName: 'Timestamp', type: 'string', width: 130, headerAlign: 'center', align: 'center' },
        {
            field: 'activeCoalition',
            headerName: 'Coalition',
            cellClassName: (data: GridCellParams) => {
                if (data.value === 'BLUE') {
                    return 'blue'
                }
                return 'red'
            },
            type: 'string',
            width: 150,
            headerAlign: 'center',
            align: 'left'
        },
        { field: 'activePlayerName', headerName: 'Player Name', type: 'string', width: 200, headerAlign: 'center', align: 'left' },
        { field: 'activePlayerVehicle', headerName: 'Vehicle', type: 'string', width: 130, headerAlign: 'center', align: 'left' },
        { field: 'weaponUsed', headerName: 'Weapon Used', type: 'string', width: 150, headerAlign: 'center', align: 'left' },
        {
            field: 'victimCoalition',
            headerName: 'Coalition',
            cellClassName: (data: GridCellParams) => {
                if (data.value === 'BLUE') {
                    return 'blue'
                }
                return 'red'
            },
            type: 'string',
            width: 150,
            headerAlign: 'center',
            align: 'left'
        },
        { field: 'victimPlayerName', headerName: 'Player Name', type: 'string', width: 200, headerAlign: 'center', align: 'left' },
        { field: 'victimPlayerVehicle', headerName: 'Vehicle', type: 'string', width: 130, headerAlign: 'center', align: 'left' },
        { field: 'category', headerName: 'Category', type: 'string', width: 140, headerAlign: 'center', align: 'left' }
    ];

	return (
        <Grid
            item
            xs={12}
        >
            <Table rows={events ? events as  GridRowData: null} editTable={false} columns={headers} />
        </Grid>
	)
}
export default Events ;
